import React, { useMemo } from 'react';
import { curryRight } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildTrimSummariesPath,
  InventoryCoreConfigurationsModel,
} from 'client/data/models/inventory-core-configurations';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { getTrimSummary } from 'site-modules/personalized-search/utils/get-trim-summary';

export const withTrimSummary = curryRight((Component, { path }) => {
  const WrappedComponent = props => {
    const { trims, trim, ...rest } = props;

    const trimSummary = useMemo(() => {
      if (!trims) {
        return trims;
      }

      return getTrimSummary(trims, trim?.value);
    }, [trim?.value, trims]);

    return <Component trimSummary={trimSummary} trim={trim} {...rest} />;
  };

  WrappedComponent.displayName = `withTrimSummary(${Component.displayName || Component.name})`;

  return connectToModel(WrappedComponent, {
    trims: bindToPath(
      path || (({ vehicle }) => vehicle && buildTrimSummariesPath(getParamsFromVehicle(vehicle))),
      InventoryCoreConfigurationsModel,
      null,
      false
    ),
  });
});
